// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"CompanyIntroSection_subtitle__NlXK5","cardContainer":"CompanyIntroSection_cardContainer__6R_ij","cardBox":"CompanyIntroSection_cardBox__eQyXi"};